export default `
  subscription OnDeleteCardAttachment($workflowId: String) {
    onDeleteCardAttachment(workflowId: $workflowId) {
      id
      cardId
      workflowId
    }
  }
`
